import React from 'react';
import { useHistory } from 'react-router-dom';

const DownloadApp = () => {
  const history = useHistory();

  const handlePlayStoreRedirect = () => {
    // Replace with your actual Play Store URL
    window.open('https://play.google.com/store/apps/details?id=com.project.acceede_teacher', '_blank');
  };

  const handleContinueToWeb = () => {
    history.push('/signin');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        {/* Success Card */}
        <div className="bg-white rounded-2xl shadow-xl p-8 text-center">
          {/* Success Icon */}
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-6">
            <svg className="h-8 w-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>

          {/* Success Message */}
          <h1 className="text-2xl font-bold text-gray-900 mb-4">
            Welcome to Acceede! 🎉
          </h1>
          
          <p className="text-gray-600 mb-6 leading-relaxed">
            Your account has been successfully created. For the best experience, 
            download our mobile app to access all features on the go.
          </p>

          {/* Download Button */}
          <button
            onClick={handlePlayStoreRedirect}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-4 px-6 rounded-xl mb-4 transition-all duration-200 transform hover:scale-105 shadow-lg hover:shadow-xl"
          >
            📱 Download on Google Play Store
          </button>

          {/* Continue to Web Option */}
          <button
            onClick={handleContinueToWeb}
            className="w-full text-gray-600 hover:text-gray-800 font-medium py-3 px-6 rounded-xl border-2 border-gray-200 hover:border-gray-300 transition-all duration-200"
          >
            Continue on Web
          </button>

          {/* App Features Preview */}
          <div className="mt-8 pt-6 border-t border-gray-100">
            <h3 className="text-sm font-semibold text-gray-700 mb-3">
              What you'll get with the app:
            </h3>
            <div className="space-y-2 text-sm text-gray-600">
              <div className="flex items-center justify-center">
                <span className="mr-2 text-green-500">✓</span>
                Better performance and user experience
              </div>
              <div className="flex items-center justify-center">
                <span className="mr-2 text-green-500">✓</span>
                Push notifications for important updates
              </div>
              <div className="flex items-center justify-center">
                <span className="mr-2 text-green-500">✓</span>
                On the go access to your school work
              </div>
            </div>
          </div>
        </div>

        {/* Footer Note */}
        <p className="text-center text-xs text-gray-500 mt-6">
          Having trouble? Contact support at{' '}
          <a href="mailto:support@acceede.com" className="text-blue-600 hover:underline">
            support@acceede.com
          </a>
        </p>
      </div>
    </div>
  );
};

export default DownloadApp; 